module.exports = __webpack_public_path__ + "static/media/transfer.7b2d8f12.svg";